import React, { ReactElement, useEffect, useState } from 'react'
import { get_site_designs } from '../services/api'
import { ISiteDesign } from '../models/IApiResponses'
import { connect, useDispatch } from 'react-redux'
import { guestAuth, setGuestUser, setSiteDesigns } from '../store/actions'
import Notification from '../components/Notification'
import { INotification, IState } from '../models/IState'

interface GuestLayoutProps {
    children: ReactElement
    notifications: INotification[]
    user_capcha: boolean
}

const GuestLayout: React.FC<GuestLayoutProps> = ({
                                                     children,
                                                     notifications,
                                                     user_capcha
                                                 }) => {
    const dispatch = useDispatch()
    const [bg, setBg] = useState<ISiteDesign[]>([])

    useEffect(() => {
        const hostname = window.location.hostname
        const isUADomain =
            // hostname.includes('localhost') || // временно для теста
            hostname.includes('smartcafe.com.ua')

        if (isUADomain) {
            localStorage.setItem('currentLocale', 'ua_UA')
        }
        get_site_designs().then(res => {
            const siteDesign = res.data[0]
            // Сохраняем данные в локальное хранилище
            localStorage.setItem('verificationAlways', siteDesign.verification_always.toString())

            dispatch(
              setGuestUser({
                  id: res.data[0].id,
                  org: res.data[0].org,
                  org_name: res?.data[0]?.org_name,
                  title: res.data[0].title,
                  title_color: res.data[0].title_color,
                  is_show_name: res.data[0].is_show_name,
                  text_shadow: res.data[0].text_shadow,
                  privacy_policy_link: res.data[0].privacy_policy_link,
                  verification_always: res.data[0].verification_always,
                  use_call_check: res.data[0].hasOwnProperty('use_call_check')
                    ? res.data[0].use_call_check!
                    : false,
                  use_telegram_check: res.data[0].hasOwnProperty('use_telegram_check')
                    ? res.data[0].use_telegram_check!
                    : false,
                  capcha_check: res.data[0].capcha_check
              })
            )
            dispatch(setSiteDesigns(res.data[0]))
            setBg(res.data)
        })/*
        если что потом вернуть
        if (localStorage.getItem('isExsistingUser') && !localStorage.getItem('guestToken')) {
            // @ts-ignore
            dispatch(guestAuth(localStorage.getItem('phone')))
        }*/
    }, [])

    const bgImage = () => {
        return `url('${
          window.innerWidth > 700
            ? bg[0]?.background
            : bg[0]?.background_mobile
        }')`
    }

    return (
      <div className='w-full vh-100 flex justify-center items-center bg-white'>
          <div
            className='h-full w-full flex justify-center items-center bg-center bg-no-repeat bg-cover bg-blue-300'
            style={{
                backgroundImage: bgImage()
            }}
          >
              <div className='absolute top-0 right-0'>
                  {notifications.map(item => (
                    <Notification notification={item} key={item.id} />
                  ))}
              </div>
              {children}
          </div>
      </div>
    )
}

function mapStateToProps(state: IState) {
    console.log('mapStateToProps - capcha_check:', state.guestUser.capcha_check)
    return {
        notifications: state.notifications,
        user_capcha: state.guestUser.capcha_check
    }
}

export default connect(mapStateToProps)(GuestLayout)
